export default {
  refreshData: 'engineering.refreshData',
  refreshDataTab: 'engineering.refreshDataTab',
  print: 'engineering.print',
  onImportSimulation: 'engineering.onImportSimulation',
  onSimulationPointsListEmpty: 'engineering.onSimulationPointsListEmpty',
  onSimulationHeaderSuccess: 'engineering.onSimulationHeaderSuccess',
};
